<template>
  <div class="chat-window">
    <div class="chat-window-content">
      <div class="chat-window__head">
        <div class="chat-window__head__icon"></div>
        <div class="chat-window__head__title">Canlı Destek Merkezi</div>
        <div class="chat-window__head__buttons" @click="minimize()">
          <div class="chat-window__head__buttons__minimize"></div>
        </div>
      </div>
      <div class="chat-window__content">
        <div class="chat-window__content__description">
          Müşteri temsilcimizin size daha iyi hizmet verebilmesi için lütfen bizimle aşağıdaki bilgileri paylaşınız.
          <br /><br />
          Müşteri temsilcilerimiz hafta içi 09:00 - 19:00 saatleri arasında hizmet vermektedir.
        </div>
        <div class="chat-window__content__form">
          <form-input v-model="form.data.name" :title="'Ad Soyad'" :isBorder="true" />
          <form-email v-model="form.data.mail" :title="'E-posta adresiniz'" :isBorder="true" />
          <form-phone v-model="form.data.phone" :title="'Telefon numaranız'" :placeholder="''" :isBorder="true" />
        </div>
        <form-button :text="'Görüşmeyi Başlat'" @action="startChat()" :size="'full'" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1
    },
    form: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    startChat: function () {
      this.$emit('changeStep', 3)
    },
    minimize: function () {
      this.$emit('changeStep', 1)
    }
  }
}
</script>